import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AppOrganizationSettings } from './../../../configs/app-organization-settings.config'

const count = 5;
const fakeDataUrl = 'https://randomuser.me/api/?results=5&inc=name,gender,email,nat&noinfo';

@Component({
  selector: 'app-demo-dash',
  templateUrl: './demo-dash.component.html',
  styleUrls: ['./demo-dash.component.scss']
})

export class DemoDashComponent implements OnInit {


  constructor(private http: HttpClient, 
    private msg: NzMessageService,
    private appOrganizationSettings:AppOrganizationSettings
    ) {}

    organizationMetaData = null;
  ngOnInit(): void {
    this.change();
    this.organizationMetaData = this.appOrganizationSettings.getOrganizationMetaData();

    setTimeout(() => {
      this.introDrawer = true;
    }, 3400);

    this.getData((res: any) => {
      this.data = res.results;
      this.list = res.results;
      this.initLoading = false;
    });
  }

  isCollapsed = false;
  triggerTemplate = null;

  //@ViewChild('trigger') customTrigger: TemplateRef<void>;
  /** custom trigger can be TemplateRef ** /
   changeTrigger(): void {
    this.triggerTemplate = this.customTrigger;
  }
   /* */

  mode = false;

  loading = true;
  change(): void {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  }

  introDrawer = false;
  closeIntroDrawer(): void {
    this.introDrawer = false;
  }

  nodes = [
    {
      title   : 'R2 Head Office',
      key     : '100',
      expanded: true,
      icon    : 'anticon anticon-user-add',
      children: [
        { title: 'Jade Heyland', key: '1001', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Lenny Mathews', key: '1001', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'John Smith (YOU)', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Thomas Vegel', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Richard Danison', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
      ]
    }
  ];

  colorScheme = {
    domain: ['#5AA454', '#1890ff', '#A10A28', '#EEEEEE']
  };
  
  chartss: any[] = [
    {
      "name": "Leads",
      "value": 24
    },
    {
      "name": "Quotes",
      "value": 12
    },
    {
      "name": "Policies",
      "value": 8
    },
  ];

  chart_commissions = [
    {
      "name": "Commissions",
      "series": [
        {
          "value": 4731,
          "name": "Jan"
        },
        {
          "value": 5130,
          "name": "Feb"
        },
        {
          "value": 4977,
          "name": "Mar"
        },
        {
          "value": 5654,
          "name": "Apr"
        },
        {
          "value": 6087,
          "name": "May"
        },
        {
          "value": 6087,
          "name": "May"
        },
        {
          "value": 6590,
          "name": "Jun"
        },
        {
          "value": 7192,
          "name": "Jul"
        },
        {
          "value": 8990,
          "name": "Aug"
        },
        {
          "value": 10110,
          "name": "Sep"
        }
      ]
    },
  ];

  data_itemCrossSell = [
    'Peter Gerald (Motor; MH28990-1001) is travelling abroad next week',
    'Ivan Yor (Health; H72666-4001) recently bought a new car',
    'Steve Ryan Smith (Motor; M278110-4890) recently bought a new car',
    'Mary Ann (Health; HI72689-4009) recently bought a new house',
  ];

  data_itemUpSell = [
    'Adam Lavine ● +62 21 29298686 ● adam@yuatcha.com (Internal Lead)',
    'Jake Lively ● +62 21 23892009 ● jake.liv@gmail.com (Internal Lead)',
    'Ryan Heir   ● +62 28 30992891 ● rheir@yahoomail.com (Internal Lead)',
    'Jane Foster ● +62 22 21986382 ● jfoster@mksky.com (Internal Lead)',
  ];

  initLoading = true; // bug
  loadingMore = false;
  data = [];
  list = [];

  perfModalisVisible = false;
  showPerformanceModal(): void {
    this.perfModalisVisible = !this.perfModalisVisible;
  }

  getData(callback: (res: any) => void): void {
    this.http.get(fakeDataUrl).subscribe((res: any) => callback(res));
  }

  onLoadMore(): void {
    this.loadingMore = true;
    ///this.list = this.data.concat();
    this.http.get(fakeDataUrl).subscribe((res: any) => {
      this.data = this.data.concat(res.results);
      this.list = [this.data];
      this.loadingMore = false;
    });
  }

  edit(item: any): void {
    this.msg.success("Loading ... ");
  }


  data_list_big = new Array(5).map((i, index) => {
    return {
      href: 'http://ant.design',
      title: `ant design part ${index}`,
      avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
      description: 'Ant Design, a design language for background applications, is refined by Ant UED Team.',
      content: 'We supply a series of design principles, practical patterns and high quality design resources (Sketch and Axure), to help people create their product prototypes beautifully and efficiently.'
    };
  });

}
